import React from 'react';
// import logo from './logo.svg';
//go to tech nerds webaite react .jS and  take the code from it 
//blog-channel.com domain name
import Portfolio from './components/Portfolio';


import './App.css';

function App() {
  const portfolioLinks = [
    {
      title: 'Dragonball Z',
      caption: 'Illustration'
    },
    {
      title: 'Deagonball Legends',
      caption: 'Graphic Design'
    },
    {
      title: 'Dragon Ball Xenoverse2',
      caption: 'Identity'
    },
    {
      title: 'Dragonball Fghter',
      caption: 'Branding'
    }
  
  ]

  return (
    <div className="App">
      <nav className="navbar navbar-expand-lg navbar-dark fixed-top" id="mainNav">
    <div className="container">
      <a className="navbar-brand js-scroll-trigger" href="#page-top">Wutang Rochi</a>
      <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="true" aria-label="Toggle navigation">
      Scroll down 
        <i className="fa fa-bars"></i>
      </button>
      <div className="collapse navbar-collapse" id="navbarResponsive">
        <ul className="navbar-nav text-uppercase ml-auto">
          <li className="nav-item">
            <a className="nav-link js-scroll-trigger" href="#services">Content</a>
          </li>
          <li className="nav-item">
            <a className="nav-link js-scroll-trigger" href="#portfolio">Images</a>
          </li>
          <li className="nav-item">
            <a className="nav-link js-scroll-trigger" href="#contact">Contact</a>
          </li>
       
        </ul>
      </div>
    </div>
  </nav>

  
  <header className="masthead">
    <div className="container">
      <div className="intro-text">
        <div className="intro-lead-in">Welcome To Wutang Rochi Website</div>
        <div className="intro-heading text-uppercase">  short introduction to the channel</div>

      </div>
    </div>
  </header>
  <h2 className="section-heading text-uppercase">About</h2>
          <h3 className="section-subheading text-muted">the introduction to the channel </h3>
          <p className="text-muted">I am sure Y'all Dragon ball loving people came here to see awesome dragon ball  content . which will be the main focus of the channel but if the fans want me to Pick different games I am down for it. Main focus will be on dragon ball legends and dragon ball dokkan battle which i am new at but willing to learn with Y'all. even the odd manga and talking about all things Dragonball</p>
          <img src= {require('./2.jpg').default} height = {180} width = {180}/>
  <h2 className="section-heading text-uppercase">Channel overlay </h2>

  <img src= {require('./1.png').default} height = {700} width = {410}/>
  <div className="intro-heading text-uppercase"> click the link below to the channel</div>
        <a className="btn btn-primary btn-xl text-uppercase js-scroll-trigger" href="https://www.youtube.com/channel/UCE1-z8zmQK491qhAIR-Jfwg">CLick Me</a>
       <hr></hr>
   <h1>Proceed by scrollling down </h1>
   <img src= {require('./2.jpg').default} height = {180} width = {170}/>
       <section className="page-section" id="services">
    <div className="container">
    <div className="row1">
        <div className="col-lg-12 text-center">
<h1></h1>
        
<hr></hr>

          <h2 className="section-heading text-uppercase">DB Content on the channel</h2>

        </div>
      </div>
      <div className="row text-center">
        <div className="col-md-4">
          <span className="fa-stack fa-4x">
            <i className="fa fa-circle fa-stack-2x text-primary"></i>
            <i className="fa fa-shopping-cart fa-stack-1x fa-inverse"></i>
          </span>
          <h4 className="service-heading">Dragon ball Fighter Z</h4>
          <p className="text-muted">Here we play a famous game that is 2d in nature called dragon ball fighters takes place in the dragon ball world</p>
        </div>
        <div className="col-md-4">
          <span className="fa-stack fa-4x">
            <i className="fa fa-circle fa-stack-2x text-primary"></i>
            <i className="fa fa-laptop fa-stack-1x fa-inverse"></i>
          </span>
          <h4 className="service-heading">Dragon ball Legends</h4>
          <p className="text-muted">Here we play a famous game  on mobile called dragon ball legends where we play pvp and single player to optain the best cards in the game. </p>
          
        </div>
        <div className="col-md-4">
          <span className="fa-stack fa-4x">
            <i className="fa fa-circle fa-stack-2x text-primary"></i>
            <i className="fa fa-lock fa-stack-1x fa-inverse"></i>
          </span>
          <h4 className="service-heading">Dragonball Xenvoerse Series</h4>
          <p className="text-muted">here we play a game mostly doing mod features in dragon ball xenoverse 2 where we do show case of characters.</p>

  
<h1></h1>


        </div>
      </div>
    </div>
    <hr></hr>
  </section>
  <hr></hr>

  <h1>Fan Manga Coming Soon</h1>
  
  <img src= {require('./3.jpg').default} height = {480} width = {410}/>
<h1></h1>
<hr></hr>
  <Portfolio portfolioLinks={portfolioLinks}></Portfolio>


  

  <section className="page-section" id="contact">
    <div className="container">
      <div className="row">
        <div className="col-lg-12 text-center">
          <h2 className="section-heading text-uppercase">Contact Me</h2>
          <h3 className="section-subheading text-muted">For more infromation </h3>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <form id="contactForm" name="sentMessage" novalidate="novalidate">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <input className="form-control" id="name" type="text" placeholder="Your Name *" required="required" data-validation-required-message="Please enter your name."/>
                  <p className="help-block text-danger"></p>
                </div>
                <div className="form-group">
                  <input className="form-control" id="email" type="email" placeholder="Your Email *" required="required" data-validation-required-message="Please enter your email address."/>
                  <p className="help-block text-danger"></p>
                </div>
              
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <textarea className="form-control" id="message" placeholder="Your Message *" required="required" data-validation-required-message="Please enter a message."></textarea>
                  <p className="help-block text-danger"></p>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="col-lg-12 text-center">
                <div id="success"></div>
                <button id="sendMessageButton" className="btn btn-primary btn-xl text-uppercase" type="submit">Send Message</button>
              </div>
             <hr></hr>
     
        <div id="Me2">
          
        </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>


  <footer className="footer">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-md-4">
          <span className="copyright">Made by Chimwemwem Chilambe 
         &copy; blog-channel 2021</span>
        </div>
        <div className="col-md-4">
          <ul className="list-inline social-buttons">
            <li className="list-inline-item">
              <a href="#something">
                <i className="fa fa-twitter"></i>
              </a>
            </li>
            <li className="list-inline-item">
              <a href="#something">
                <i className="fa fa-facebook-f"></i>
              </a>
            </li>
            <li className="list-inline-item">
              <a href="#something">
                <i className="fa fa-linkedin-in"></i>
              </a>
              
            </li>
          </ul>
        </div>
        <div className="col-md-4">
          <ul className="list-inline quicklinks">
            <li className="list-inline-item">
              <a href="https://mail.google.com/">ChimwemweChilambe@gmail.com</a>
            </li>
            <li className="list-inline-item">
              <a href="#something"></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
    </div>
  );
}

export default App;
